import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom'; // Import Link for internal navigation

const ServicesOverview = () => {
  const services = [
    {
      id: 1,
      title: "Event Decor & Styling",
      slug: "event-decor-and-styling", // SEO-friendly URL
      description: "We are visual storytellers, transforming spaces into immersive environments that captivate guests and create an unforgettable atmosphere.",
      icon: "Palette",
      features: [
        "Full Event & Theme Conceptualization",
        "Bespoke Floral Design & Installation",
        "Ambiant Lighting & A/V Design",
        "Luxury Furniture & Linen Curation",
      ]
    },
    {
      id: 2,
      title: "Corporate Events",
      slug: "corporate-events", // SEO-friendly URL
      description: "Professional corporate event planning for conferences, product launches, and company celebrations with attention to brand representation.",
      icon: "Briefcase",
      features: ["Conference Planning", "Product Launches", "Team Building", "Brand Events"]
    },
    {
      id: 3,
      title: "Private Celebrations",
      slug: "private-celebrations", // SEO-friendly URL
      description: "Intimate gatherings and milestone celebrations including birthdays, anniversaries, and family reunions tailored to your vision.",
      icon: "Gift",
      features: ["Birthday Parties", "Traditional Events", "Anniversaries", "Family Reunions"]
    },
    {
      id: 4,
      title: "Premium Rentals & Logistics",
      slug: "premium-rentals-and-logistics", // SEO-friendly URL
      description: "Sourcing luxury furniture, managing large-scale tenting, and executing complex A/V and lighting production for a flawless event.",
      icon: "Truck",
      features: ["Luxury Furniture & Decor", "Tent & Structure Management", "Lighting & A/V Production", "Power & Site Operations"]
    },
    {
      id: 5,
      title: "VIP Socials & Lifestyle Events",
      slug: "vip-socials-and-lifestyle-events", // SEO-friendly URL
      description: "Curating exclusive, high-profile social experiences for luxury brands and private clients, from influencer gatherings to charity galas.",
      icon: "Star",
      features: ["Exclusive Launch Parties", "Influencer & Media Events", "Luxury Brand Activations", "Charity Galas"]
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-foreground mb-4">
            Our Premium Event Services
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            From immersive decor to grand corporate events, we specialize in creating unforgettable experiences. Explore our services to see how we bring visions to life.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-card elevation-card rounded-lg p-6 flex flex-col hover:elevation-floating transition-smooth hover-scale group"
            >
              <div className="flex-grow">
                {/* Service Icon */}
                <div className="mb-6">
                  <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center group-hover:scale-105 transition-smooth">
                    <Icon name={service.icon} size={28} color="white" />
                  </div>
                </div>

                {/* Service Content */}
                <div className="mb-6">
                  <h3 className="font-heading font-bold text-xl text-foreground mb-3">
                    {service.title}
                  </h3>
                  <p className="font-body text-muted-foreground mb-4 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features List */}
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center space-x-2">
                        <Icon name="Check" size={16} className="text-accent flex-shrink-0" />
                        <span className="font-body text-sm text-muted-foreground">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* --- CTA BUTTON UPDATED --- */}
              <Link to={`/services/${service.slug}`} className="mt-auto">
                <Button
                  variant="outline"
                  fullWidth
                  className="group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary transition-smooth"
                >
                    Learn More
                    <Icon name="ArrowRight" size={16} className="ml-2" />
                </Button>
              </Link>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <Link to="/services">
            <Button
              variant="default"
              size="lg"
              className="px-8"
            >
              <Icon name="Eye" size={20} className="mr-2" />
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;